import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";
import { enqueueSnackbar } from "notistack";

import { runGqlMutation } from "gqlClient";
import {
  CancelFormChangeAlertDocument,
  GetFormChangeAlertTimerDocument,
  SendFormChangeAlertDocument,
} from "generated/graphql";

type LensUpdateSnackbarContextType = {
  enqueueLensUpdateTimerSnackbar: (lensId: number) => void;
  timer: number | undefined;
  setTimer: Dispatch<SetStateAction<number | undefined>> | undefined;
};
const initialState: LensUpdateSnackbarContextType = {
  enqueueLensUpdateTimerSnackbar: () => {},
  timer: undefined,
  setTimer: undefined,
};

export const LensUpdateSnackbarContext = createContext<LensUpdateSnackbarContextType>(initialState);

export function LensUpdateSnackbarProvider({ children }: { children: ReactNode }) {
  const [timer, setTimer] = useState<number | undefined>(undefined);
  const enqueueLensUpdateTimerSnackbar = (lensId: number) =>
    runGqlMutation(GetFormChangeAlertTimerDocument, { lensId }).then((r) => {
      const timerResult = r.lens.form.getFormChangeAlertTimer;
      if (setTimer) {
        setTimer(timerResult ?? undefined);
        if (timer === undefined || timer === null) {
          enqueueSnackbar("", {
            variant: "lensEditorAlert",
            persist: true,
            onCancel: () => runGqlMutation(CancelFormChangeAlertDocument, { lensId }),
            onSend: () => runGqlMutation(SendFormChangeAlertDocument, { lensId }),
          });
        }
      }
    });
  return (
    <LensUpdateSnackbarContext.Provider value={{ enqueueLensUpdateTimerSnackbar, timer, setTimer }}>
      {children}
    </LensUpdateSnackbarContext.Provider>
  );
}
